import { z } from 'zod';
export var IconSpec = z
    .object({
    type: z.enum(['none', 'current', 'file', 'sprite', 'itemId']),
})
    .catchall(z.any());
export var IconNoneSpec = IconSpec.extend({
    type: z.literal('none'),
});
export var IconCurrentSpec = IconSpec.extend({
    type: z.literal('current'),
});
export var IconFileSpec = IconSpec.extend({
    type: z.literal('file'),
    filePath: z.string().optional(),
});
export var IconSpriteSpec = IconSpec.extend({
    type: z.literal('sprite'),
    spriteId: z.number().optional(),
    spriteIndex: z.number().optional(),
});
export var IconItemIdSpec = IconSpec.extend({
    type: z.literal('itemId'),
    itemId: z.number().optional(),
});
